import { transparentColors } from "../../assets/styles/helpers/colors.styles";
export const backDropStyles = {
  zIndex: 0,
  background: transparentColors.whiteShade3,
  backdropFilter: "blur(4px)",
  maxWidth: "480px",
  margin: "0 auto",
};
